module.exports = __webpack_public_path__ + "b045c79fcb2a5ae59bc7cc71fc484245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/velikonocni-tabor-5.jpg
// module id = 1205
// module chunks = 0